import {
  CollectionType,
  OrderStatus,
  OrderType,
  ReportOrder
} from 'services/api/types';

const reports: ReportOrder[] = [
  {
    collection_type: CollectionType.delivery,
    total_value: '20.32',
    delivery_time: '2021-10-01 05:37',
    id: 1,
    user_name: 'Natasha Romanova',
    created_at: '2021-10-01 04:37',
    payment_type: OrderType.individual,
    state: OrderStatus.placed,
    email: 'foo@foodpanda.com',
    code: 'sahgd213-csdca'
  },
  {
    collection_type: CollectionType.delivery,
    total_value: '60.92',
    delivery_time: '2021-10-11 05:37',
    id: 2,
    user_name: 'Steve Roger',
    created_at: '2021-10-11 04:37',
    payment_type: OrderType.individual,
    state: OrderStatus.delivered,
    email: 'foo@foodpanda.com',
    code: 'sahgd213-cscd4ca'
  },
  {
    collection_type: CollectionType.delivery,
    total_value: '14.20',
    delivery_time: '2021-10-11 05:37',
    id: 3,
    user_name: 'Tony Stark',
    created_at: '2021-10-11 04:37',
    payment_type: OrderType.individual,
    state: OrderStatus.delivered,
    email: 'foo@foodpanda.com',
    code: 'sahgd213-cs3422ca'
  },
  {
    collection_type: CollectionType.delivery,
    total_value: '19.92',
    delivery_time: '2021-10-11 05:37',
    id: 4,
    user_name: 'Bruce Banner',
    created_at: '2021-10-11 04:37',
    payment_type: OrderType.individual,
    state: OrderStatus.delivered,
    email: 'foo@foodpanda.com',
    code: 'sasdgd213-csdca'
  },
  {
    collection_type: CollectionType.delivery,
    total_value: '60.92',
    delivery_time: '2021-10-11 05:37',
    id: 5,
    user_name: 'Foo',
    created_at: '2021-10-11 04:37',
    payment_type: OrderType.individual,
    state: OrderStatus.cancelled,
    email: 'foo@foodpanda.com',
    code: 'sazfcd213-csdca'
  },
  {
    collection_type: CollectionType.delivery,
    total_value: '14.20',
    delivery_time: '2021-10-11 05:37',
    id: 6,
    user_name: 'Foo',
    created_at: '2021-10-11 04:37',
    payment_type: OrderType.individual,
    state: OrderStatus.placed,
    email: 'foo@foodpanda.com',
    code: 's23213-csdca'
  },
  {
    collection_type: CollectionType.delivery,
    total_value: '19.92',
    delivery_time: '2021-10-11 05:37',
    id: 7,
    user_name: 'Foo',
    created_at: '2021-10-11 04:37',
    payment_type: OrderType.individual,
    state: OrderStatus.cancelled,
    email: 'foo@foodpanda.com',
    code: 'sah23gd213-csdca'
  },
  {
    collection_type: CollectionType.delivery,
    total_value: '19.92',
    delivery_time: '2021-10-11 05:37',
    id: 8,
    user_name: 'Foo',
    created_at: '2021-10-11 04:37',
    payment_type: OrderType.individual,
    state: OrderStatus.cancelled,
    email: 'foo@foodpanda.com',
    code: 'sa234hgd213-csdca'
  },
  {
    collection_type: CollectionType.delivery,
    total_value: '19.92',
    delivery_time: '2021-10-11 05:37',
    id: 9,
    user_name: 'Foo',
    created_at: '2021-10-11 04:37',
    payment_type: OrderType.individual,
    state: OrderStatus.placed,
    email: 'foo@foodpanda.com',
    code: 'sahgd213-cs234a'
  },
  {
    collection_type: CollectionType.delivery,
    total_value: '19.92',
    delivery_time: '2021-10-11 05:37',
    id: 10,
    user_name: 'Foo',
    created_at: '2021-10-11 04:37',
    payment_type: OrderType.individual,
    state: OrderStatus.placed,
    email: 'foo@foodpanda.com',
    code: 'sahgd213-csdc'
  },
  {
    collection_type: CollectionType.delivery,
    total_value: '19.92',
    delivery_time: '2021-10-11 05:37',
    id: 2349,
    user_name: 'Foo',
    created_at: '2021-10-11 04:37',
    payment_type: OrderType.individual,
    state: OrderStatus.placed,
    email: 'foo@foodpanda.com',
    code: 'sahgd213-csda'
  },
  {
    collection_type: CollectionType.delivery,
    total_value: '19.92',
    delivery_time: '2021-10-11 05:37',
    id: 133,
    user_name: 'Foo',
    created_at: '2021-10-11 04:37',
    payment_type: OrderType.individual,
    state: OrderStatus.delivered,
    email: 'foo@foodpanda.com',
    code: 'sahgd213-csa'
  },
  {
    collection_type: CollectionType.delivery,
    total_value: '19.92',
    delivery_time: '2021-10-11 05:37',
    id: 142,
    user_name: 'Foo',
    created_at: '2021-10-11 04:37',
    payment_type: OrderType.individual,
    state: OrderStatus.delivered,
    email: 'foo@foodpanda.com',
    code: 'd213-csdca'
  },
  {
    collection_type: CollectionType.delivery,
    total_value: '19.92',
    delivery_time: '2021-10-11 05:37',
    id: 164,
    user_name: 'Foo',
    created_at: '2021-10-11 04:37',
    payment_type: OrderType.individual,
    state: OrderStatus.delivered,
    email: 'foo@foodpanda.com',
    code: 'sgd213-csdca'
  },
  {
    collection_type: CollectionType.delivery,
    total_value: '19.92',
    delivery_time: '2021-10-11 05:37',
    id: 24,
    user_name: 'Foo',
    created_at: '2021-10-11 04:37',
    payment_type: OrderType.individual,
    state: OrderStatus.delivered,
    email: 'foo@foodpanda.com',
    code: 'sah213-csdca'
  }
];

export default reports;
